import { useContext, useState } from "react";
import { SettingsContext, ShopContext, AlertContext } from "../App";
import Api from "./api/api";
import "../css/Pin.css";
import Label from "./Label";

const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "C", "0", "back"];
const MIN_DOTS = 4;

// Schermata PIN operatore (modalità tablet): login via /users/pin_login/
function StaffPin({ onCancel }) {
  const { settings, setStaff } = useContext(SettingsContext);
  const { shop } = useContext(ShopContext);
  const { setAlertData } = useContext(AlertContext);
  const [inputValue, setInputValue] = useState("");
  const [sending, setSending] = useState(false);

  const handleKey = (key) => {
    if (key === "C") setInputValue("");
    else if (key === "back") setInputValue((v) => v.slice(0, -1));
    else setInputValue((v) => (v.length < 12 ? v + key : v));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!inputValue || sending) return;
    setSending(true);
    const response = await Api.postWithToken("/users/pin_login/", {
      pin: inputValue,
      shop_id: shop.id,
    });
    setSending(false);
    setInputValue("");
    if (response.success === 0 || !response.token) {
      setAlertData({
        title: <Label number={70} />,
        message: response.error || "Pin errato",
        confirmMessage: <Label number={31} />,
      });
      return;
    }
    setStaff({ token: response.token, user: response.data });
  };

  const dots = Math.max(MIN_DOTS, inputValue.length);

  return (
    <div id="pin" className={"staff-pin" + (onCancel ? " staff-pin-overlay" : "")}>
      <div className="staff-pin-logo">
        <img src={settings.selfordering.logo_home} alt="Logo" />
      </div>
      <form className="staff-pin-body" onSubmit={handleSubmit}>
        <div className="staff-pin-info">
          <div className="staff-pin-eyebrow">Modalità tablet</div>
          <h2>PIN operatore</h2>
          <p>Inserisci il tuo PIN per accedere alla lista tavoli e accogliere i clienti.</p>
          <div className="staff-pin-dots" aria-label="PIN inserito">
            {Array.from({ length: dots }).map((_, i) => (
              <span key={i} className={i < inputValue.length ? "filled" : ""} />
            ))}
          </div>
        </div>
        <div className="staff-pin-pad">
          <div className="staff-pin-keys">
            {KEYS.map((key) => (
              <button
                type="button"
                key={key}
                className="staff-pin-key"
                aria-label={key === "back" ? "Cancella ultima cifra" : key === "C" ? "Azzera" : key}
                onClick={() => handleKey(key)}
              >
                {key === "back" ? "⌫" : key}
              </button>
            ))}
          </div>
          <button type="submit" className="staff-pin-submit" disabled={!inputValue || sending}>
            Accedi
          </button>
          {onCancel && (
            <button type="button" className="staff-pin-cancel" onClick={onCancel}>
              Annulla
            </button>
          )}
        </div>
      </form>
    </div>
  );
}

export default StaffPin;
